import React from 'react';

interface Size {
    width: number;
    height: number;
}

interface Props {
    size: Size;
    shouldRoundSize: boolean;
    color: string;
}

/**
 * 协作的选中框
 */
class CoopCursorBorder extends React.Component<Props> {
    public static displayName = 'SelectBorder';

    public render() {
        const size: Size = this.props.shouldRoundSize ? {
            width: Math.round(this.props.size.width),
            height: Math.round(this.props.size.height),
        } : this.props.size;
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                style={{
                    width: size.width > 10 ? size.width : 10,
                    height: size.height > 10 ? size.height : 10,
                    position: 'absolute',
                    overflow: 'visible',
                    left: 0, // 只加position，不加left，top无效
                    top: 0,
                }}
                pointerEvents={'none'}
                className='cursor-border'
            >
                <g>
                    <rect
                        x={size.width < 0.5 ? 0 : 0.5}
                        y={size.height < 0.5 ? 0 : 0.5}
                        width={size.width < 1 ? 0 : size.width - 1}
                        height={size.height < 1 ? 0 : size.height - 1}
                        stroke={this.props.color || 'black'}
                        strokeWidth={4}
                        strokeOpacity={0.6}
                        strokeLinejoin={'round'}
                        fill={'none'}
                        pointerEvents={'none'}
                    />
                </g>
            </svg>
        );
    }
}

export default CoopCursorBorder;
